import React, { useEffect, useState } from "react";
import './MasterFileTable.css';
import { Table, Spin, Form, Input, Popconfirm, Typography, Button, Pagination } from "antd";
import { selectMasterfileFrequency, updateMasterfile } from "../../Repository/MasterFileRepository";
import { EditFilled, CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";

const MasterFileTable = ({ dataColumns, selectfrequency, sendDataToParent }) => {
    const [masterData, setMasterData] = useState([])
    const [tableLoader, setTableLoader] = useState(false)
    const [rowData, setRowData] = useState([]);
    const dataCol = dataColumns
    const frequency = selectfrequency
    const [form] = Form.useForm();
    const [searchRow, setSearchRow] = useState("")
    const [editingKey, setEditingKey] = useState('');
    const [disabaleButton, setDisable] = useState(true)
    const isEditing = (record) => record.Id === editingKey;
    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        onChange={()=>setDisable(false)}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    useEffect(() => {
        if (frequency !== "") {
            let temp = frequency
            callMasterRepositoryMethod(temp)
        }
    }, [frequency])
    useEffect(() => {
        if (dataCol.length === 0) {
            columns.length = 0
        }
    }, [dataCol])
    const editableSet = [
        "temp_rate", "id", "rt_wk1", "ot_wk1", "dt_wk1", "rt_wk2", "ot_wk2", "dt_wk2", "rt_total", "ot_total", "dt_total", "sal_amnt",
        "holiday_hrs", "pto_hrs", "sick_hrs", "covid_hrs", "training_hrs", "gym_amnt", "fmla_amnt", "sevpay_amnt", "bonus_amnt",
        "missingInPaychexList", "remarks"
    ]
    const widthSet = [
        "missingInPaychexList", "sick_hrs", "covid_hrs", "training_hrs", "fmla_amnt", "sevpay_amnt", "bonus_amnt", "sal_amnt",
        'ticket_Number', 'holiday_hrs', 'remarks'
    ]
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.file_number)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.client)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.pcx_emp_name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });
    const columns = [
        { title: "File Number", dataIndex: 'file_number', key: 'file_number', fixed: "left", width: 100, ...filterProps(), },
        // { title: "Employee Name", dataIndex: "pcx_emp_name", key: 'pcx_emp_name', fixed: "left", width: 150, },
        ...dataCol.map(data => ({
            title: data.children,
            dataIndex: data.key,
            key: data.key,
            width: widthSet.includes(data.key) ? 180 : 90,
            editable: editableSet.includes(data.key) ? true : false
        })),
        {
            title: 'Action',
            dataIndex: 'operation',
            width: 70,
            fixed: "right",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editMasterfileRowData(record)} onCancel={cancel}>
                            <Typography.Link
                                style={{
                                    marginRight: 8,
                                }}
                                disabled={disabaleButton}
                            >
                                <CheckCircleFilled style={{ fontSize: 19, color: 'green' }} className="save-cancel-icon"/>
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseCircleFilled style={{ fontSize: 19, color: 'red' }} className="save-cancel-icon" />
                        </Typography.Link>
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        <EditFilled style={{ fontSize: 18, color: '#003A8C' }} />
                    </Typography.Link>
                );
            },
        }
    ]

    const callMasterRepositoryMethod = async (frequency) => {
        setTableLoader(true)
        const response = await selectMasterfileFrequency(frequency)
        if (response !== null) {
            setMasterData(response)
            sendDataToParent(response)
        }
        else {
            setMasterData([])
        }
        setTableLoader(false)
    }
    const edit = (record) => {
        setRowData(record)
        setDisable(true)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.Id);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // const compareObjects = (obj1, obj2) => {
    //     const keys1 = Object.keys(obj1);
    //     const keys2 = Object.keys(obj2);
    //     if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
    //         return false;
    //     }
    //     for (const key of keys1) {
    //         if (obj1[key] !== obj2[key]) {
    //             return false;
    //         }
    //     }
    //     return true;
    // };

    // const compareLists = (rowData, currentRowData) => {
    //     if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
    //         return false;
    //     }
    //     const result = compareObjects(rowData, currentRowData);
    //     return result;
    // };
    const editMasterfileRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            // const comparision = compareLists(rowData, currentRowData);
            // if (comparision === false) {
                const data = {
                    "temp_rate": currentRowData.temp_rate,
                    "id": currentRowData.Id,
                    "rt_wk1": currentRowData.rt_wk1,
                    "ot_wk1": currentRowData.ot_wk1,
                    "dt_wk1": currentRowData.dt_wk1,
                    "rt_wk2": currentRowData.rt_wk2,
                    "ot_wk2": currentRowData.ot_wk2,
                    "dt_wk2": currentRowData.dt_wk2,
                    "rt_total": currentRowData.rt_total,
                    "ot_total": currentRowData.ot_total,
                    "dt_total": currentRowData.dt_total,
                    "sal_amount": currentRowData.sal_amnt,
                    "holiday_hrs": currentRowData.holiday_hrs,
                    "pto_hrs": currentRowData.pto_hrs,
                    "sick_hrs": currentRowData.sick_hrs,
                    "covid_hrs": currentRowData.covid_hrs,
                    "training_hrs": currentRowData.training_hrs,
                    "gym_amnt": currentRowData.gym_amnt,
                    "fmla_amnt": currentRowData.fmla_amnt,
                    "sevpay_amnt": currentRowData.sevpay_amnt,
                    "bonus_amnt": currentRowData.bonus_amnt,
                    "missingInPaychexList": currentRowData.missingInPaychexList,
                    "remarks": currentRowData.remarks
                }
                const updateresponse = await updateMasterfile(data)
                const res = await selectMasterfileFrequency(frequency)
                if (res !== null) {
                    setMasterData(res)
                    sendDataToParent(res)
                }
                if (updateresponse.data.statusCode === 200) {
                    SuccessMessage(updateresponse.data.message)
                }
                else if (updateresponse.data.statusCode === 204) {
                    InfoMessage(updateresponse.data.message)
                }
                else {
                    ErrorMessage(updateresponse.data.message)
                }
                setEditingKey("");
            // }
        }
        catch (err) {
            return err
        }
    }
    return (<>
        <div className="masterfile-search-class">
            <Input
                placeholder="Search File Number \ Employee Name \ Client"
                className="MF-searchrow"
                style={{ borderColor: "#002766", color: "#F4F9FF" }}
                onChange={(e) => setSearchRow(e.target.value)}
                allowClear
                suffix={
                    <SearchOutlined
                        style={{ color: "#002766", justifyContent: "space-between" }}
                    />
                }
            />
        </div>
        <div className={masterData.length > 0 ? "masterfile-table-class" : "masterfile-empty-table"}>
            {
                tableLoader ? <Spin tip="Loading...">
                    <Form form={form} component={false}>
                        <Table className="masterfile-table" rowClassName="editable-row"
                            components={{ body: { cell: EditableCell, }, }}
                            columns={mergedColumns} scroll={{ x: "max-content", y: 400 }}
                            dataSource={masterData} >
                        </Table>
                    </Form> </Spin> :
                    <Form form={form} component={false}>
                        <Table className="masterfile-table" rowClassName="editable-row"
                            components={{ body: { cell: EditableCell, }, }}
                            columns={mergedColumns} scroll={{ x: "max-content", y: 400 }}
                            dataSource={masterData} >
                        </Table>
                    </Form>
            }
        </div>
    </>)
}

export default MasterFileTable;